export interface Category {
  id: string;
  name: string;
  slug: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: Category[] = [
  {
    id: "cat-1",
    name: "智能解决方案",
    slug: "smart-solutions",
    icon: "ri-brain-line",
    description: "基于人工智能技术的综合解决方案，覆盖企业运营的各个关键环节，助力数字化转型。",
    count: 48,
  },
  {
    id: "cat-2",
    name: "数据分析平台",
    slug: "data-analytics",
    icon: "ri-bar-chart-grouped-line",
    description: "强大的数据采集、清洗、分析与可视化工具，让数据真正驱动业务决策。",
    count: 36,
  },
  {
    id: "cat-3",
    name: "云服务架构",
    slug: "cloud-services",
    icon: "ri-cloud-line",
    description: "弹性、安全、高可用的云基础设施服务，满足不同规模企业的多样化需求。",
    count: 29,
  },
  {
    id: "cat-4",
    name: "安全防护体系",
    slug: "security",
    icon: "ri-shield-check-line",
    description: "全方位的网络安全防护方案，从威胁检测到应急响应，守护您的数字资产。",
    count: 22,
  },
  {
    id: "cat-5",
    name: "物联网平台",
    slug: "iot-platform",
    icon: "ri-router-line",
    description: "连接万物，智能感知。一站式物联网管理平台，实现设备互联与数据互通。",
    count: 31,
  },
  {
    id: "cat-6",
    name: "企业协同工具",
    slug: "collaboration",
    icon: "ri-team-line",
    description: "高效团队协作套件，集沟通、任务、文档于一体，释放团队无限潜能。",
    count: 25,
  },
];

export const categoryProducts: Record<string, { id: string; name: string; description: string; features: string[]; image: string }[]> = {
  "smart-solutions": [
    {
      id: "prod-1-1",
      name: "aiye 智能决策引擎",
      description: "基于深度学习的智能决策系统，实时分析海量数据，自动生成最优策略建议，帮助企业做出更精准的商业判断。",
      features: ["实时数据分析", "自适应学习", "多维度决策支持", "可视化报告"],
      image: "https://readdy.ai/api/search-image?query=Modern%20AI%20decision%20engine%20dashboard%20interface%20with%20clean%20design%20warm%20terracotta%20accents%20minimalist%20data%20visualization%20professional%20software%20product%20showcase&width=600&height=400&seq=prod-smart-1&orientation=landscape",
    },
    {
      id: "prod-1-2",
      name: "aiye 流程自动化套件",
      description: "让重复性工作自动完成。覆盖财务、人事、运营等核心业务流程，释放团队创造力，提升整体组织效能。",
      features: ["可视化流程设计", "跨系统集成", "智能异常处理", "操作审计追踪"],
      image: "https://readdy.ai/api/search-image?query=Workflow%20automation%20software%20interface%20with%20clean%20modern%20design%20cream%20and%20terracotta%20color%20scheme%20minimalist%20professional%20product%20showcase&width=600&height=400&seq=prod-smart-2&orientation=landscape",
    },
    {
      id: "prod-1-3",
      name: "aiye 智能客服系统",
      description: "全天候在线的智能客服解决方案，自然语言理解准确率高达 97%，大幅降低人工客服成本，提升用户满意度。",
      features: ["多轮对话引擎", "情感识别", "知识图谱", "无缝人机协作"],
      image: "https://readdy.ai/api/search-image?query=Intelligent%20customer%20service%20chat%20interface%20modern%20design%20with%20warm%20tones%20clean%20minimal%20UI%20professional%20software%20product%20showcase&width=600&height=400&seq=prod-smart-3&orientation=landscape",
    },
  ],
  "data-analytics": [
    {
      id: "prod-2-1",
      name: "aiye 数据洞察平台",
      description: "一站式数据分析与洞察平台，从数据接入到可视化呈现，帮助团队快速发现数据背后的商业机会。",
      features: ["拖拽式仪表盘", "实时数据流", "自定义报表", "智能预警"],
      image: "https://readdy.ai/api/search-image?query=Data%20analytics%20dashboard%20with%20charts%20and%20graphs%20modern%20clean%20design%20warm%20cream%20and%20terracotta%20color%20scheme%20professional%20product%20showcase&width=600&height=400&seq=prod-data-1&orientation=landscape",
    },
    {
      id: "prod-2-2",
      name: "aiye 商业智能套件",
      description: "面向企业决策层的商业智能工具，将复杂数据转化为清晰洞察，以数据驱动战略规划与执行。",
      features: ["CEO 驾驶舱", "多维分析", "预测建模", "行业对标"],
      image: "https://readdy.ai/api/search-image?query=Business%20intelligence%20BI%20dashboard%20interface%20modern%20minimalist%20design%20warm%20neutral%20tones%20professional%20product%20showcase&width=600&height=400&seq=prod-data-2&orientation=landscape",
    },
    {
      id: "prod-2-3",
      name: "aiye 用户行为分析",
      description: "深入理解用户行为轨迹，构建精准用户画像。优化产品体验与营销策略，实现用户价值最大化。",
      features: ["热力图分析", "漏斗分析", "用户分层", "A/B 测试"],
      image: "https://readdy.ai/api/search-image?query=User%20behavior%20analytics%20heatmap%20dashboard%20modern%20clean%20design%20terracotta%20and%20cream%20color%20scheme%20professional%20product%20showcase&width=600&height=400&seq=prod-data-3&orientation=landscape",
    },
  ],
  "cloud-services": [
    {
      id: "prod-3-1",
      name: "aiye 弹性云主机",
      description: "高性能、高可用的云主机服务，秒级弹性伸缩，按需付费，满足从初创到大型企业的多样化计算需求。",
      features: ["秒级部署", "弹性伸缩", "99.99% SLA", "全球多区域"],
      image: "https://readdy.ai/api/search-image?query=Cloud%20server%20infrastructure%20visualization%20modern%20clean%20design%20with%20warm%20neutral%20tones%20professional%20product%20showcase%20minimalist&width=600&height=400&seq=prod-cloud-1&orientation=landscape",
    },
    {
      id: "prod-3-2",
      name: "aiye 容器服务平台",
      description: "基于 Kubernetes 的企业级容器管理平台，简化应用的部署、运维与扩展，让团队专注业务创新。",
      features: ["一键部署", "自动扩缩容", "多集群管理", "CI/CD 集成"],
      image: "https://readdy.ai/api/search-image?query=Container%20orchestration%20platform%20interface%20modern%20minimalist%20design%20terracotta%20and%20cream%20tones%20professional%20product%20showcase&width=600&height=400&seq=prod-cloud-2&orientation=landscape",
    },
  ],
  "security": [
    {
      id: "prod-4-1",
      name: "aiye 安全态势感知",
      description: "实时监测全网安全态势，智能识别潜在威胁，主动防御网络攻击，构建全方位的安全防护体系。",
      features: ["实时威胁检测", "攻击溯源", "漏洞扫描", "合规审计"],
      image: "https://readdy.ai/api/search-image?query=Cybersecurity%20dashboard%20with%20threat%20monitoring%20modern%20clean%20design%20warm%20neutral%20tones%20professional%20product%20showcase&width=600&height=400&seq=prod-sec-1&orientation=landscape",
    },
    {
      id: "prod-4-2",
      name: "aiye 数据加密网关",
      description: "端到端的数据加密解决方案，保障数据在存储、传输、使用全生命周期的安全，满足最严格的合规要求。",
      features: ["国密算法支持", "透明加密", "密钥管理", "审计日志"],
      image: "https://readdy.ai/api/search-image?query=Data%20encryption%20security%20gateway%20visualization%20modern%20minimalist%20design%20terracotta%20and%20cream%20tones%20professional%20product%20showcase&width=600&height=400&seq=prod-sec-2&orientation=landscape",
    },
  ],
  "iot-platform": [
    {
      id: "prod-5-1",
      name: "aiye 物联网设备管理",
      description: "统一的物联网设备接入与管理平台，支持海量设备并发连接，实现设备全生命周期管理。",
      features: ["设备快速接入", "远程配置", "OTA 升级", "状态监控"],
      image: "https://readdy.ai/api/search-image?query=IoT%20device%20management%20dashboard%20with%20connected%20devices%20visualization%20modern%20clean%20design%20warm%20neutral%20tones%20professional%20product%20showcase&width=600&height=400&seq=prod-iot-1&orientation=landscape",
    },
    {
      id: "prod-5-2",
      name: "aiye 边缘计算节点",
      description: "靠近数据源头的边缘计算方案，大幅降低延迟，节省带宽成本，让实时数据处理更加高效可靠。",
      features: ["低延迟处理", "离线自治", "边缘AI推理", "云边协同"],
      image: "https://readdy.ai/api/search-image?query=Edge%20computing%20node%20visualization%20modern%20minimalist%20design%20terracotta%20and%20cream%20tones%20professional%20product%20showcase&width=600&height=400&seq=prod-iot-2&orientation=landscape",
    },
  ],
  "collaboration": [
    {
      id: "prod-6-1",
      name: "aiye 团队协作空间",
      description: "一站式的团队协作平台，集即时通讯、文档协作、项目管理于一体，让远程办公如同面对面。",
      features: ["实时协作文档", "项目管理看板", "视频会议", "知识库"],
      image: "https://readdy.ai/api/search-image?query=Team%20collaboration%20platform%20interface%20modern%20clean%20design%20warm%20neutral%20tones%20minimalist%20professional%20product%20showcase&width=600&height=400&seq=prod-collab-1&orientation=landscape",
    },
    {
      id: "prod-6-2",
      name: "aiye 项目管理套件",
      description: "敏捷开发与项目管理的专业工具，甘特图、看板、燃尽图一应俱全，轻松驾驭复杂项目。",
      features: ["甘特图", "Scrum 看板", "资源管理", "工时统计"],
      image: "https://readdy.ai/api/search-image?query=Project%20management%20software%20kanban%20board%20interface%20modern%20minimalist%20design%20terracotta%20and%20cream%20tones%20professional%20product%20showcase&width=600&height=400&seq=prod-collab-2&orientation=landscape",
    },
  ],
};